import type { ContractReviewForm } from "../types/template";

/** Minimum fields required before Apply / Generate in template review. */
export const isCoreContractReviewFormValid = (input: {
  contractName: string;
  businessUnit: string;
  contractOrigination: string;
  effectiveDate: string;
}): boolean =>
  input.contractName.trim().length > 0 &&
  input.businessUnit.trim().length > 0 &&
  input.contractOrigination.trim().length > 0 &&
  input.effectiveDate.trim().length > 0;

/** Build payload with empty optional merge fields when client/rep/plan are omitted. */
export const buildContractReviewFormPayload = (input: {
  contractName: string;
  templateId: string;
  contractType: string;
  businessUnit: string;
  contractOrigination: string;
  effectiveDate: string;
  legalEntityId: string;
  legalEntityName: string;
  contactName: string;
  contactTitle: string;
  representativeId: string;
  representativeName: string;
  representativeTitle: string;
  representativeCompanyName: string;
  representativeAddress: string;
  representativeStreetAddress: string;
  representativeCityStateZip: string;
  representativePhone: string;
  representativeEmail: string;
  planGroupName: string;
  addressMerged: string;
  companyStreetAddress: string;
  companyCityStateZip: string;
  phone: string;
  email: string;
}): ContractReviewForm | null => {
  if (
    !isCoreContractReviewFormValid({
      contractName: input.contractName,
      businessUnit: input.businessUnit,
      contractOrigination: input.contractOrigination,
      effectiveDate: input.effectiveDate,
    })
  ) {
    return null;
  }

  return {
    contractName: input.contractName.trim(),
    templateId: input.templateId,
    contractType: input.contractType,
    businessUnit: input.businessUnit.trim(),
    contractOrigination: input.contractOrigination.trim(),
    effectiveDate: input.effectiveDate.trim(),
    legalEntityId: input.legalEntityId.trim() ? input.legalEntityId : null,
    legalEntityName: input.legalEntityName.trim(),
    contactName: input.contactName.trim(),
    contactTitle: input.contactTitle.trim(),
    representativeId: input.representativeId.trim() ? input.representativeId : null,
    representativeName: input.representativeName.trim(),
    representativeTitle: input.representativeTitle.trim(),
    representativeCompanyName: input.representativeCompanyName.trim(),
    representativeAddress: input.representativeAddress.trim(),
    representativeStreetAddress: input.representativeStreetAddress.trim(),
    representativeCityStateZip: input.representativeCityStateZip.trim(),
    representativePhone: input.representativePhone.trim(),
    representativeEmail: input.representativeEmail.trim(),
    planGroupName: input.planGroupName.trim(),
    addressMerged: input.addressMerged.trim(),
    companyStreetAddress: input.companyStreetAddress.trim(),
    companyCityStateZip: input.companyCityStateZip.trim(),
    phone: input.phone.trim(),
    email: input.email.trim(),
  };
};
